import React from 'react';

// COMMON/DEAFULT IMAGES
import { ReactComponent as Sales } from '../../assets/images/dollarSign.svg';
import { ReactComponent as Reports } from '../../assets/images/reports.svg';
import { ReactComponent as Resources } from '../../assets/images/resources.svg';
import { ReactComponent as Claims } from '../../assets/images/tools.svg';
import { ReactComponent as ContractActive } from '../../assets/images/contract-active.svg';
import { ReactComponent as ContractPending } from '../../assets/images/contract-pending.svg';
import { ReactComponent as SaleIncomplete } from '../../assets/images/sale-incomplete.svg';
import { ReactComponent as Advantage } from '../../assets/images/shield-check.svg';
import { ReactComponent as Dealer } from '../../assets/images/dealer.svg';
import { ReactComponent as Enroll } from '../../assets/images/enrollment.svg';
import { ReactComponent as HandRevenue } from '../../assets/images/hand-revenue.svg';
import { ReactComponent as Revenue } from '../../assets/images/revenue.svg';
import { ReactComponent as People } from '../../assets/images/people.svg';
import { ReactComponent as Satisfaction } from '../../assets/images/satisfaction.svg';
import { ReactComponent as Loyalty } from '../../assets/images/ratings.svg';
import { ReactComponent as AdvantageCheck } from '../../assets/images/shield-circle-checkmark.svg';
import { ReactComponent as StandoutIcon } from '../../assets/images/stand-out.svg';
import { ReactComponent as Lock } from '../../assets/images/lock.svg';
import { ReactComponent as Graph } from '../../assets/images/graph.svg';
import { ReactComponent as Checkboxes } from '../../assets/images/checkboxes.svg';
import { ReactComponent as ClaimReject } from '../../assets/images/canceled.svg';
import { ReactComponent as Contact } from '../../assets/images/contact.svg';
import { ReactComponent as Successful } from '../../assets/images/success.svg';
import { ReactComponent as Profile } from '../../assets/images/profile.svg';
import { ReactComponent as ProfileAlert } from '../../assets/images/profile-alert.svg';
import { ReactComponent as UploadIcon } from '../../assets/images/upload-circle.svg';
import { ReactComponent as Email } from '../../assets/images/email.svg';
import { ReactComponent as ClaimReview } from '../../assets/images/review.svg';
import { ReactComponent as ClaimApprove } from '../../assets/images/success.svg';
import { ReactComponent as Error } from '../../assets/images/exclamation_circle.svg';

// DEFAULT AIG
// import {ReactComponent as Successful } from '../../assets/images/Vendor/AIG/successfull.svg'
// import {ReactComponent as Contact } from '../../assets/images/Vendor/AIG/contact.svg'
// import {ReactComponent as Enroll } from '../../assets/images/Vendor/AIG/revenue.svg'
// import {ReactComponent as Error } from '../../assets/images/Vendor/AIG/exclamation.svg'
// import {ReactComponent as Email } from '../../assets/images/Vendor/AIG/email-sent.svg'
// import {ReactComponent as Checkboxes } from '../../assets/images/Vendor/AIG/checkboxes.svg';
// import {ReactComponent as Ratings } from '../../assets/images/Vendor/AIG/ratings.svg';
// import {ReactComponent as Graph } from '../../assets/images/Vendor/AIG/graph.svg';
// import {ReactComponent as Lock } from '../../assets/images/Vendor/AIG/lock.svg';
// import {ReactComponent as Profile } from '../../assets/images/Vendor/AIG/profile.svg';
// import {ReactComponent as UploadIcon } from '../../assets/images/Vendor/AIG/upload-circle.svg';
// import {ReactComponent as ClaimApprove} from '../../assets/images/Vendor/AIG/claim-saved.svg';
// import {ReactComponent as ClaimReject} from '../../assets/images/Vendor/AIG/claim-cancelled.svg';
// import {ReactComponent as ClaimReview} from '../../assets/images/Vendor/AIG/claim-review.svg';

//GE
import { ReactComponent as GEHandshakeCircle } from '../../assets/images/Vendor/GE/handshake-circle.svg';
import { ReactComponent as GEPaperCircle } from '../../assets/images/Vendor/GE/paper-circle.svg';
import { ReactComponent as GEPeopleCircle } from '../../assets/images/Vendor/GE/people-circle.svg';
import { ReactComponent as GEProfileCircle } from '../../assets/images/Vendor/GE/profile-circle.svg';
import { ReactComponent as GEVerificationCircle } from '../../assets/images/Vendor/GE/verification-circle.svg';
import { ReactComponent as GEQuotation } from '../../assets/images/Vendor/GE/quote-mark.svg';

//ICP
import { ReactComponent as ICPLoginPortal } from '../../assets/images/Vendor/ICP/login-portal.svg';
import { ReactComponent as ICPShieldIcon } from '../../assets/images/Vendor/ICP/ComfortPromise_Icon.svg';

//Home Depot
import { ReactComponent as HDLoginPortal } from '../../assets/images/Vendor/HomeDepot/Login-hd.svg';
import { ReactComponent as HDIncreaseBenefitsIcon } from '../../assets/images/Vendor/HomeDepot/increase-benefits.svg';
import { ReactComponent as HDPartnerWithCustomersIcon } from '../../assets/images/Vendor/HomeDepot/partner-with-customers.svg';
import { ReactComponent as HDMinimalStartupIcon } from '../../assets/images/Vendor/HomeDepot/minimal-startup.svg';
import { ReactComponent as HDCheckWithCircleIcon } from '../../assets/images/Vendor/HomeDepot/Check-with-circle.svg';

//Staples
import { ReactComponent as StaplesCopy } from '../../assets/images/Vendor/Staples/copy.svg';

//MCC
import { ReactComponent as MCCLoginPortal } from '../../assets/images/Vendor/MCC/Login-mcc.svg';
import { ReactComponent as MCCPatnershipIcon } from '../../assets/images/Vendor/MCC/partnership.svg';
import { ReactComponent as MCCReferralIcon } from '../../assets/images/Vendor/MCC/referrals.svg';
import { ReactComponent as MCCSuperheroIcon } from '../../assets/images/Vendor/MCC/superhero.svg';
import { ReactComponent as MCCValueIcon } from '../../assets/images/Vendor/MCC/value.svg';
import { ReactComponent as MCCEarnIcon } from '../../assets/images/Vendor/MCC/earn.svg';
import { ReactComponent as MCCCheckboxSelectedLanding } from '../../assets/images/Vendor/MCC/checkbox_selected_landing-mcc.svg';

//Grayscale
import { ReactComponent as GrayscaleTermsError } from '../../assets/images/Vendor/Grayscale/claim-cancelled-grayscale.svg';
import { ReactComponent as GrayscaleInvalidError } from '../../assets/images/Vendor/Grayscale/exclamation-circle-grayscale.svg';
import { ReactComponent as GrayscaleEmailError } from '../../assets/images/Vendor/Grayscale/email-sent-grayscale.svg';

//Trane
import { ReactComponent as TraneCheckboxSelectedLanding } from '../../assets/images/Vendor/Trane/checkbox_selected_landing-Trane.svg';
import { ReactComponent as TraneLoginPortal } from '../../assets/images/Vendor/Trane/Login.svg';

//Nordyne
import { ReactComponent as NordyneCheckboxSelectedLanding } from '../../assets/images/Vendor/Nordyne/checkbox_selected_landing_Nordyne.svg';
import { ReactComponent as NordyneLoginPortal } from '../../assets/images/Vendor/Nordyne/Login-Nordyne.svg';
import { ReactComponent as NordynePeopleDifferentIcon } from '../../assets/images/Vendor/Nordyne/differentiate-yourself.svg';
import { ReactComponent as NordyneIncreaseRevenueIcon } from '../../assets/images/Vendor/Nordyne/increase-revenue-Nordyne.svg';
import { ReactComponent as NordyneSatisfactionIcon } from '../../assets/images/Vendor/Nordyne/customer-satisfaction.svg';

//Mainline Plus
import { ReactComponent as MainlineProfits } from '../../assets/images/Vendor/MainlinePlus/money-growth.svg';
import { ReactComponent as MainlinePayment } from '../../assets/images/Vendor/MainlinePlus/payment-card.svg';
import { ReactComponent as MainlineRatings } from '../../assets/images/Vendor/MainlinePlus/customer-ratings.svg';
import { ReactComponent as MainlineCoverage } from '../../assets/images/Vendor/MainlinePlus/clipboard.svg';
import { ReactComponent as MainlineOnline } from '../../assets/images/Vendor/MainlinePlus/electronics.svg';
import { ReactComponent as MainlineHandsRevenue } from '../../assets/images/Vendor/MainlinePlus/hand-revenue.svg';

import styles from './WhiteLabeling.module.css';

const BrandedIcon = ({ accountName, iconType }) => {
    const getIcon = () => {
        const accountNameLower = () => {
            let accountNameLower = accountName.toLowerCase();
        };

        let accountNameToLower = accountName.toLowerCase().replace(/ /g, '');

        // REPEAT THIS "IF" FOR EACH NEW BRAND

        if (accountNameToLower === 'trane') {
            if (iconType.toLowerCase() === 'papercircle') return <Enroll />;
            if (iconType.toLowerCase() === 'login') return <TraneLoginPortal />;
            if (iconType.toLowerCase() === 'checkboxlanding') return <TraneCheckboxSelectedLanding />;
        }
        if (accountNameToLower === 'ge') {
            if (iconType.toLowerCase() === 'handshakecircle') return <GEHandshakeCircle />;
            if (iconType.toLowerCase() === 'papercircle') return <GEPaperCircle />;
            if (iconType.toLowerCase() === 'peoplecircle') return <GEPeopleCircle />;
            if (iconType.toLowerCase() === 'profilecircle') return <GEProfileCircle />;
            if (iconType.toLowerCase() === 'verificationcircle') return <GEVerificationCircle />;
            if (iconType.toLowerCase() === 'quotation') return <GEQuotation />;
        }
        if (accountNameToLower === 'icp') {
            if (iconType.toLowerCase() === 'papercircle') return <Enroll />;
            if (iconType.toLowerCase() === 'login') return <ICPLoginPortal />;
            if (iconType.toLowerCase() === 'shield') return <ICPShieldIcon />;
        }
        if (accountNameToLower === 'homedepot') {
            if (iconType.toLowerCase() === 'login') return <HDLoginPortal />;
            if (iconType.toLowerCase() === 'shield') return <Advantage />;
            if (iconType.toLowerCase() === 'increasebenefits') return <HDIncreaseBenefitsIcon />;
            if (iconType.toLowerCase() === 'partnerwithcustomer') return <HDPartnerWithCustomersIcon />;
            if (iconType.toLowerCase() === 'minimalstartup') return <HDMinimalStartupIcon />;
            if (iconType.toLowerCase() === 'checkwithcircle') return <HDCheckWithCircleIcon />;
        }

        if (accountNameToLower === 'staples') {
            if (iconType.toLowerCase() === 'copy') return <StaplesCopy />;
        }

        if (accountNameToLower === 'mcc') {
            if (iconType.toLowerCase() === 'login') return <MCCLoginPortal />;
            if (iconType.toLowerCase() === 'shield') return <Advantage />;
            if (iconType.toLowerCase() === 'partnership') return <MCCPatnershipIcon />;
            if (iconType.toLowerCase() === 'earn') return <MCCEarnIcon />;
            if (iconType.toLowerCase() === 'value') return <MCCValueIcon />;
            if (iconType.toLowerCase() === 'referral') return <MCCReferralIcon />;
            if (iconType.toLowerCase() === 'superhero') return <MCCSuperheroIcon />;
            if (iconType.toLowerCase() === 'checkboxlanding') return <MCCCheckboxSelectedLanding />;
            if (iconType.toLowerCase() === 'enroll') return <Enroll />;
        }

        if (accountNameToLower === 'grayscale') {
            if (iconType.toLowerCase() === 'denied') return <GrayscaleTermsError />;
            if (iconType.toLowerCase() === 'error') return <GrayscaleInvalidError />;
            if (iconType.toLowerCase() === 'email') return <GrayscaleEmailError />;
        }

        if (accountNameToLower === 'nordyne') {
            if (iconType.toLowerCase() === 'papercircle') return <Enroll />;
            if (iconType.toLowerCase() === 'login') return <NordyneLoginPortal />;
            if (iconType.toLowerCase() === 'checkboxlanding') return <NordyneCheckboxSelectedLanding />;
            if (iconType.toLowerCase() === 'differentpeople') return <NordynePeopleDifferentIcon />;
            if (iconType.toLowerCase() === 'increaserevenue') return <NordyneIncreaseRevenueIcon />;
            if (iconType.toLowerCase() === 'satisfaction') return <NordyneSatisfactionIcon />;
            if (iconType.toLowerCase() === 'enroll') return <Enroll />;
        }

        if (accountNameToLower === 'mainline') {
            if (iconType?.toLowerCase() === 'profits') return <MainlineProfits />;
            if (iconType?.toLowerCase() === 'payment') return <MainlinePayment />;
            if (iconType?.toLowerCase() === 'customers') return <MainlineRatings />;
            if (iconType?.toLowerCase() === 'coverage') return <MainlineCoverage />;
            if (iconType?.toLowerCase() === 'online') return <MainlineOnline />;
            if (iconType?.toLowerCase() === 'servicerevenue') return <MainlineHandsRevenue />;
        }

        // FALLTHROUGH IF CLIENT NOT DEFINED OR NO MATCH FOUND / Common Images
        if (iconType.toLowerCase() === 'sales') return <Sales />;
        if (iconType.toLowerCase() === 'reports') return <Reports />;
        if (iconType.toLowerCase() === 'resources') return <Resources />;
        if (iconType.toLowerCase() === 'claims') return <Claims />;
        if (iconType.toLowerCase() === 'active') return <ContractActive />;
        if (iconType.toLowerCase() === 'pending') return <ContractPending />;
        if (iconType.toLowerCase() === 'incomplete') return <SaleIncomplete />;
        if (iconType.toLowerCase() === 'advantage') return <Advantage />;
        if (iconType.toLowerCase() === 'advantagecheck') return <AdvantageCheck />;
        if (iconType.toLowerCase() === 'successful') return <Successful />;
        if (iconType.toLowerCase() === 'contact') return <Contact />;
        if (iconType.toLowerCase() === 'enroll') return <Revenue />;
        if (iconType.toLowerCase() === 'dealer') return <Dealer />;
        if (iconType.toLowerCase() === 'error') return <Error />;
        if (iconType.toLowerCase() === 'email') return <Email />;
        if (iconType.toLowerCase() === 'checkboxes') return <Checkboxes />;
        if (iconType.toLowerCase() === 'ratings') return <Satisfaction />;
        if (iconType.toLowerCase() === 'graphs') return <Graph />;
        if (iconType.toLowerCase() === 'lock') return <Lock />;
        if (iconType.toLowerCase() === 'profile') return <Profile />;
        if (iconType.toLowerCase() === 'profilealert') return <ProfileAlert />;
        if (iconType.toLowerCase() === 'circleupload') return <UploadIcon />;
        if (iconType.toLowerCase() === 'approved') return <ClaimApprove />;
        if (iconType.toLowerCase() === 'denied') return <ClaimReject />;
        if (iconType.toLowerCase() === 'review') return <ClaimReview />;
        if (iconType.toLowerCase() === 'revenuehand') return <HandRevenue />;
        if (iconType.toLowerCase() === 'people') return <People />;
        if (iconType.toLowerCase() === 'verificationpaper') return <Enroll />;
        if (iconType.toLowerCase() === 'standout') return <StandoutIcon />;
        if (iconType.toLowerCase() === 'loyalty') return <Loyalty />;
        // FALLTHROUGH IF NO MATCH ON CLIENT OR TYPE.
        return null;
    };

    return <div className={styles.variableIconWrapper}>{getIcon()}</div>;
};

export default BrandedIcon;
